module.exports = __webpack_public_path__ + "static/media/personal-protective-equipment-test-reports.7accb47e.svg";